export const NroComprobanteColumn = ({
  nrocomprobante,
  tipocomprobante_nombre,
}) => {
  return (
    <>
      <h5
        style={{
          margin: 0,
        }}
      >
        {nrocomprobante}
      </h5>
      <h6
        style={{
          margin: 0,
        }}
      >
        {tipocomprobante_nombre}
      </h6>
    </>
  );
};
